var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oauth-wrapper"},[_c('img',{staticClass:"asset",attrs:{"src":require("@/assets/images/doodles/oauth-success.jpg"),"alt":"Installation successfull"}}),_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.message))]),_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/logo.png"),"alt":"Macha Logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }